module.exports = __webpack_public_path__ + "static/media/top-bg.7f2a1ac2.png";